"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSpotIndividualTickerUpdate = void 0;
const binance_1 = require("../../types/binance");
const isSpotIndividualTickerUpdate = (event) => {
    return event.eventType === binance_1.EWsBinanceSpotMarketEventTypes.individualTicker;
};
exports.isSpotIndividualTickerUpdate = isSpotIndividualTickerUpdate;
